import {Component, OnInit} from '@angular/core';
import {WatchService} from '../watch/services/watch.service';
import {FormService} from '../management/application-management/form/services/form.service';
import {formatDate} from "@angular/common";
import saveAs from "file-saver";
import {FileApiService} from "../../shared/services/file-api/file-api.service";
import {AuthService} from "../../shared/services/auth/auth.service";

type GroupedData = {
  [key: string]: any[];
};

@Component({
  selector: 'app-vehicle-control',
  templateUrl: './vehicle-control.component.html',
  styleUrl: './vehicle-control.component.scss',
})
export class VehicleControlComponent implements OnInit {
  constructor(
    private readonly watchService: WatchService,
    private readonly formService: FormService,
    private readonly fileService: FileApiService,
    private readonly authService: AuthService
  ) {
    this.token = this.authService.getToken() ?? '';
  }

  token: string;
  loading: boolean = false;
  filterCollaps: boolean = false;
  minDate: Date | null = null;
  vehicleOptions: any[] = [];
  formOptions: any[] = [];
  selectedDriver: any = 'Sürücü 1';
  selectedNurse: any = 'Hemşire 1';
  selectedDoctor: any = 'Doktor 1';
  searchForm: string = '';
  searchQuestion: string = '';
  formList: any[] = [];
  filteredList: any[] = [];
  selectedForm: any = null;
  groupedList: any[] = [];
  collapsedGroups: { [key: string]: boolean } = {};

  filter: any = {
    date: null,
    vehicle: null,
    form: null,
  };
  answersList: { [key: string]: any[] } = {};
  filteredAnswersList: { [key: string]: any[] } = {};

  ngOnInit(): void {
    this.minDate = new Date();
  }

  clearFilter() {
    this.filter = {
      date: null,
      vehicle: null,
      formTab: null,
    };
  }

  onDateChange(event: Date): void {
    this.loading = true;
    this.watchService.getVehiclesDropdownByDate({date: event}).subscribe({
      next:(res) => {
        this.vehicleOptions = res?.map((item) => ({
          label: item?.vehicle?.licensePlate,
          value: Number(item?.vehicle?.id),
          operationVehicleTypeId: item?.vehicle?.operationVehicleTypeId,
        }));
        this.loading = false;
      },
      error:(err) => {
        this.loading = false;
      }
    });
  }

  onVehicleChange(vehicleId: any) {
    // Seçilen öğeyi vehicleOptions listesinden bul

    this.formList = [];
    this.filteredList = [];
    this.groupedList = [];
    this.filteredAnswersList = {};
    const selectedVehicle = this.vehicleOptions.find(
      (option) => option.value === vehicleId
    );

    // Seçilen öğeyi detaylarıyla birlikte konsola yazdır
    if (selectedVehicle) {
      this.loading = true;
      this.formService
        .dropdownFormByOperationVehicle({
          operationVehicleTypeId: selectedVehicle?.operationVehicleTypeId,
        })
        .subscribe({
          next:(res) => {
            this.formOptions = res?.map((item) => ({
              label: item?.title,
              value: Number(item?.id),
            }));
            const tempList = res?.map((r) => {
              return r?.formMenus?.map((fm: any) => ({
                formTitle: r?.title,
                formId: r?.id,
                title: fm?.title,
                id: fm?.id,
                isActive: fm?.isActive,
              }));
            });
            const flattened = tempList.flat();
            this.formList = flattened;
            this.filteredList = [...flattened]; 
            this.updateGroupedList();
            this.loading = false;
          },
          error: (err) => {
            this.loading = false;
          }
        });
    }
  }

  onSelectFormItem(formTabId: number) {
    this.searchForm = '';
    // seçilen form u form listesinden bul
    if (formTabId) {
      const selectedForm = this.formOptions.find(
        (option) => option.value === formTabId
      );
      if (selectedForm) {
        this.filteredList = this.formList.filter((i) => i?.formId === formTabId);
      }
      this.selectedForm = null;
      this.answersList = {};
    }
  }

  handleSearch() {
    // eğer search text boş ise
    if (this?.searchForm?.trim()?.length === 0) {
      // seçili form tab var ise
      if (this.filter?.formTab) {// eğer var ise filtrelenmiş liste seçili formTabId olan olsun
        this.filteredList = this.formList?.filter((f) => f.formId === this.filter?.formTab);
      } else {// yok ise filtrelenmiş liste tüm from listesi olsun
        this.filteredList = this.formList;
      }

    } else if (this.filter?.formTab){
        this.filteredList = this.formList?.filter((f) => f.formId === this.filter?.formTab).filter(
          (item) =>
            item.title.toLowerCase().includes(this.searchForm.toLowerCase()) ||
            item.formTitle.toLowerCase().includes(this.searchForm.toLowerCase())
        );
      }
      else {
        this.filteredList = this.formList?.filter(
          (item) =>
            item.title.toLowerCase().includes(this.searchForm.toLowerCase()) ||
            item.formTitle.toLowerCase().includes(this.searchForm.toLowerCase())
        );
      }
    

  }

  onFormSelect(formTab: any) {
    this.answersList = {};
    if (this.selectedForm === formTab) {
      this.selectedForm = null;
    } else {
      this.loading = true;
      this.selectedForm = formTab;
      this.formService
        .getAnswersByFilters({
          formId: formTab?.formId,
          formMenuId: formTab?.id,
          vehicleId: this.filter.vehicle,
          date: formatDate(this.filter.date, 'yyyy-MM-ddTHH:mm:ss', 'tr-TR')
        })
        .subscribe({
          next:(res) => {
            for(const answer of res){
              const tabKey = `${answer.formTab?.title}`;

              if (!this.answersList[tabKey]) {
                this.answersList[tabKey] = [];
              }

              this.answersList[tabKey].push({
                formTabId: answer.formTabId,
                formTabTitle: answer.formTab?.title,
                formTabItem: answer.formTabItem,
                answerValue: answer.answerValue,
                answerLabel: answer.answerLabel,
                description: answer?.description,
                createdAt: answer?.createdAt,
              });
            }
            this.filteredAnswersList = this.getFilteredAnswersList();
            this.loading = false;
          },
          error: (err) => {
            this.loading = false;
          }
        });
    }
  }

  get objectKeys() {
    return Object.keys;
  }


  onSearchChange() {
    this.filteredAnswersList = this.getFilteredAnswersList();
  }

  getFilteredAnswersList(): { [key: string]: any[] } {
    if (!this.searchQuestion || this.searchQuestion.trim() === '') {
      return this.answersList;
    }

    const filtered: { [key: string]: any[] } = {};
    const query = this.searchQuestion.toLowerCase();
    for(const tabKey of Object.keys(this.answersList)){
      const filteredAnswers = this.answersList[tabKey].filter(answer => {
        const question = answer?.formTabItem?.title?.toLowerCase() || '';
        const answerText = answer?.answerLabel?.toLowerCase() || '';
        const description = answer?.description?.toLowerCase() || '';

        return (
          tabKey.toLowerCase().includes(query) ||
          question.includes(query) ||
          answerText.includes(query) ||
          description.includes(query)
        );
      });

      if (filteredAnswers.length > 0) {
        filtered[tabKey] = filteredAnswers;
      }
    }

    return filtered;
  }


  getGroupedList(): any[] {
    const groups: { [key: string]: any[] } = {};
    for(const item of this.filteredList){
      const key = item.id; // id'ye göre grupluyoruz
      if (!groups[key]) {
        groups[key] = [];
      }
      groups[key].push(item);
    }

    // object → diziye dönüştür
    return Object.keys(groups).map((key) => ({
      id: key,
      title: groups[key][0].title, // grup başlığı olarak title
      items: groups[key],
    }));
  }

  updateGroupedList() {
    const groups: { [key: string]: any[] } = {};
    for(const item of this.filteredList){
      const key = item.id;
      if (!groups[key]) groups[key] = [];
      groups[key].push(item);
    }

    this.groupedList = Object.keys(groups).map((key) => ({
      id: key,
      title: groups[key][0].title,
      items: groups[key],
    }));

    // varsayılan olarak hepsi kapalı
    this.collapsedGroups = {};
    for(const g of this.groupedList){
      this.collapsedGroups[g.id] = false
    }
  }


  download(doc: string) {
    this.fileService.getFileBlob(doc, this.token)
      .subscribe((blob) => {
        saveAs(blob);
      });
  }

  toggleGroup(id: string) {
    this.collapsedGroups[id] = !this.collapsedGroups[id];
  }
}
